import { NgModule } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
  IconCamera,
  IconBold,
  IconItalic,
  IconUnderline,
  IconStrikethrough,
  IconAlignLeft,
  IconAlignRight,
  IconAlignJustified,
  IconMinus,
  IconSend2,
  IconUser,
  IconChevronsDown,
  IconArrowNarrowLeft,
  IconArrowForwardUp,
  IconTarget,
  IconCreditCard,
  IconWallet,
  IconCrown,
  IconPlayerPause,
  IconHeart,
  IconInfoTriangleFilled,
  IconExternalLink,
  IconCornerDownRight,
  IconBrandFacebook,
  IconPlugConnected,
  IconBrandMeta,
  IconArrowRight,
  IconSend,
  IconPaperclip,
  IconPencil,
  IconLinkOff,
  IconCalendar,
  IconBorderAll,
  IconStar,
  IconStars,
  IconBrandGithub,
  IconMessages,
  IconInbox,
  IconAccessibleOffFilled,
  IconUpload,
  IconPhotoUp,
  IconArrowUp,
  IconCopy,
  IconAdCircleFilled,
  IconAdCircleOff,
  IconTrash,
  IconX,
  IconAlertCircle,
  IconSearch,
  IconMail,
  IconEye,
  IconEyeOff,
  IconArrowDown,
  IconAccessibleOff,
  IconAdOff,
  IconAdCircle,
  IconCircleCheckFilled,
  IconAlertTriangleFilled,
  IconInfoCircleFilled,
  IconAlertCircleFilled,
  IconCircleXFilled,
  IconCheck,
  IconSpeakerphone,
  IconHeadset,
  IconClock,
  IconChevronRight,
  IconTable,
  IconAlignCenter,
  IconArrowLeft,
  IconChevronsRight,
  IconChevronsLeft,
  IconSettings,
  IconMessageCircle,
  IconAddressBook,
  IconBrandWindows,
  IconFilter,
  IconFilterFilled,
  IconArchive,
  IconPin,
  IconPinFilled,
  IconVolume3,
  IconVolume,
  IconDots,
  IconBaselineDensityMedium,
  IconFileText,
  IconStarFilled,
  IconChevronDown,
  IconEdit,
  IconChevronLeft,
  IconReload,
  IconPhoto,
  IconVideo,
  IconPlus,
  IconDownload,
  IconPointFilled,
  IconPlugOff,
  IconAlertOctagon,
  IconHandStop,
  IconRocket,
  IconWorldWww,
  IconWand,
  IconHelpCircle,
  IconChevronsUp,
  IconDotsVertical,
  IconPhone,
  IconPhoneCall,
  IconShoppingCart,
  IconArrowsRandom,
  IconUsers,
  IconWorldShare,
  IconMessage,
  IconThumbUp,
  IconClipboardText,
  IconInfoCircle,
  IconRefresh,
  IconTopologyStar3,
  IconKey,
  IconBrandGoogle,
  IconEyeClosed,
  IconHelp,
  IconPlayerPlay,
  IconChartBar,
 IconCurrencyDollar,
 IconTool,
 IconBolt,
IconCaretDownFilled,
IconMicrophone,
IconFlag,
IconArrowNarrowRight,
IconStack,
IconLoader2,
IconCut,
IconPlayerPlayFilled,
IconPlayerPauseFilled,
IconCircleX,
IconAlertTriangle,
IconGripVertical,
IconBrush,
IconVolumeOff,
IconMessageReport,
IconLayoutGrid,
IconAlignBoxLeftTop,
IconAlignBoxRightTop,
IconAlignBoxBottomLeft,
IconAlignBoxBottomRight,
IconZoomIn,
IconZoomInArea,
IconZoomOut,
IconCrop,
IconWorld,
IconRepeat,
IconAdjustmentsHorizontal,
IconLock,
IconMapPin,
IconFileUpload,
IconHistory,
IconLayout,
IconWaveSine,
IconLayoutSidebarLeftExpand,
IconLayoutSidebarLeftCollapse,
IconGift,
IconHeartHandshake,
IconArrowsMaximize,
IconSparkles,
IconRotateClockwise,
IconTrendingUp,
IconFlipVertical,
IconFlipHorizontal,
IconMap,
IconNavigation,
IconCurrentLocation,
IconMapPin2,
IconPhonePlus,
IconPhoneCalling,
IconPhoneIncoming,
IconWorldLongitude,
IconDeviceLaptop,
IconBrowser,
IconLetterCase,
IconTemplate,
IconColorFilter,
IconPalette,
IconSquare,
IconSquareCheckFilled,
IconRectangle,
IconRectangleVertical,
IconBrandSupernova,
IconMicrophoneOff,
IconCloudUpload,
IconHome,
IconBulb,
IconAd,
IconHeadphones,
IconChevronUp,
IconBox,
IconFolder,
IconMessage2,
IconDeviceMobile,
IconLink

} from 'angular-tabler-icons/icons';

const icons = {
  IconCamera,
  IconBold,
  IconItalic,
  IconUnderline,
  IconStrikethrough,
  IconAlignLeft,
  IconAlignRight,
  IconAlignJustified,
  IconMinus,
  IconCaretDownFilled,
  IconTool,
  IconPointFilled,
  IconEyeClosed,
  IconPlugOff,
IconBrandGoogle,
IconHelp,
  IconTarget,
  IconPlayerPause,
  IconKey,
  IconCornerDownRight,
  IconDotsVertical,
  IconInfoTriangleFilled,
  IconExternalLink,
  IconBrandMeta,
  IconPlugConnected,
  IconBrandFacebook,
  IconHeart,
  IconSend,
  IconPaperclip,
  IconBrandGithub,
  IconAccessibleOffFilled,
  IconArrowUp,
  IconArrowDown,
  IconChevronsDown,
  IconArrowRight,
  IconCopy,
  IconAdCircleFilled,
  IconAdCircleOff,
  IconTrash,
  IconX,
  IconUser,
  IconArrowForwardUp,
  IconAlertCircle,
  IconSearch,
  IconMail,
  IconEye,
  IconEyeOff,
  IconAccessibleOff,
  IconAdOff,
  IconStars,
  IconCalendar,
  IconPencil,
  IconStar,
  IconLinkOff,
  IconPhotoUp,
  IconMessages,
  IconAdCircle,
  IconCircleCheckFilled,
  IconAlertTriangleFilled,
  IconInfoCircleFilled,
  IconAlertCircleFilled,
  IconCircleXFilled,
  IconCheck,
  IconSpeakerphone,
  IconHeadset,
  IconClock,
  IconChevronRight,
  IconTable,
  IconAlignCenter,
  IconArrowLeft,
  IconChevronsRight,
  IconChevronsLeft,
  IconSettings,
  IconMessageCircle,
  IconAddressBook,
  IconBrandWindows,
  IconFilter,
  IconFilterFilled,
  IconArchive,
  IconPin,
  IconPinFilled,
  IconVolume3,
  IconVolume,
  IconDots,
  IconBaselineDensityMedium,
  IconInbox,
  IconUpload,
  IconBorderAll,
  IconSend2,
  IconFileText,
  IconStarFilled,
  IconChevronDown,
  IconEdit,
  IconChevronLeft,
  IconReload,
  IconPhoto,
  IconVideo,
  IconPlus,
  IconArrowNarrowLeft,
  IconDownload,
  IconAlertOctagon,
  IconHandStop,
  IconRocket,
  IconWorldWww,
  IconWand,
  IconHelpCircle,
  IconChevronsUp,
  IconCreditCard,
  IconWallet,
  IconCrown,
  IconPhone,
  IconPhoneCall,
  IconShoppingCart,
  IconArrowsRandom,
  IconUsers,
  IconWorldShare,
  IconMessage,
  IconClipboardText,
  IconThumbUp,
  IconInfoCircle,
  IconRefresh,
  IconTopologyStar3,
IconPlayerPlay,
IconChartBar,
IconCurrencyDollar,
IconBolt,
IconMicrophone,
IconFlag,
IconArrowNarrowRight,
IconStack,
IconLoader2,
IconCut,
IconPlayerPlayFilled,
IconPlayerPauseFilled,
IconCircleX,
IconAlertTriangle,
IconGripVertical,
IconBrush,
IconVolumeOff,
IconMessageReport,
IconLayoutGrid,
IconAlignBoxLeftTop,
IconAlignBoxRightTop,
IconAlignBoxBottomLeft,
IconAlignBoxBottomRight,
IconZoomIn,
IconZoomInArea,
IconZoomOut,
IconCrop,
IconRepeat,
IconAdjustmentsHorizontal,
IconLock,
IconMapPin,
IconWorld,
IconLayout,
IconWaveSine,
IconLayoutSidebarLeftExpand,
IconLayoutSidebarLeftCollapse,
IconGift,
IconHeartHandshake,
IconArrowsMaximize,
IconSparkles,
IconRotateClockwise,
IconTrendingUp,
IconFlipVertical,
IconFlipHorizontal,
      IconFileUpload,
      IconHistory,
      IconMap,
      IconNavigation,
      IconCurrentLocation,
      IconMapPin2,
      IconPhonePlus,
      IconPhoneCalling,
      IconPhoneIncoming,
      IconWorldLongitude,
      IconDeviceLaptop,
      IconBrowser,
      IconLetterCase,
      IconTemplate,
      IconColorFilter,
      IconPalette,
      IconSquare,
      IconSquareCheckFilled,
      IconRectangle,
      IconRectangleVertical,
      IconBrandSupernova,
      IconMicrophoneOff,
      IconCloudUpload,
      IconHome,
      IconBulb,
      IconAd,
      IconHeadphones,
      IconChevronUp,
      IconBox,
      IconFolder,
      IconMessage2,
      IconDeviceMobile,
      IconLink
};

@NgModule({
  imports: [TablerIconsModule.pick(icons)],
  exports: [TablerIconsModule],
})
export class IconsModule {}
